import { Component, OnInit } from '@angular/core';
import { ClientConfiguation } from '../../_enums/clientConfiguration';
import { CommonService } from '../../_services/app.common.service';

@Component({
  selector: 'app-pwned-password-instructions',
  templateUrl: './pwned-password-insturctions.component.html',
  standalone: false
})
export class PwnedPasswordInstructionsComponent implements OnInit {
  passwordAdviseUrl: string = '';
  constructor(public common: CommonService) {
  }
  ngOnInit(): void {

    let baseUrl = this.common.readClientConfiguration(ClientConfiguation.JTURL);
    baseUrl = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
    this.passwordAdviseUrl = `${baseUrl}Account/PasswordAdvice`;
  }
}

